import { Component, forwardRef, input, Resource, TemplateRef, viewChild, ChangeDetectionStrategy } from '@angular/core';

import { PanelViewBase } from '@softline/ui-core';
import { RemoteDataPanelViewBase } from '../remote-data-panel-view.base';
import { ResourceContainerComponent } from '@softapps/core';

@Component({
    selector: 'soft-remote-data-panel-view',
  imports: [ResourceContainerComponent],
    templateUrl: './remote-data.panel-view.html',
    styleUrl: './remote-data.panel-view.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: PanelViewBase, useExisting: forwardRef(() => RemoteDataPanelView) },
        { provide: RemoteDataPanelViewBase, useExisting: forwardRef(() => RemoteDataPanelView) }
    ]
})
export class RemoteDataPanelView<T> extends RemoteDataPanelViewBase<T> {
  override name = input.required<string>();
  override label = input<string>('Data');
  override icon = input<string>('fa-regular fa-grid-2');
  override template = viewChild<TemplateRef<any>>('template');
  override resource = input.required<Resource<T>>();
}
